<template>
  <div class="d-flex align-center justify-center fill-height" v-if="loading">
    <Loader label="Загрузка данных GSA..." />
  </div>
  <v-card v-else class="fill-height">
    <keep-alive>
      <router-view />
    </keep-alive>
  </v-card>
  
</template>

<script>
import Loader from '../components/ui/Loader.vue'

export default {
  data: () => ({
    loading: true
  }),
  methods:{
    async load_gsa_data(){
      this.loading = true
      await Promise.all([
        this.$store.dispatch('load_gsa_list'),
        this.$store.dispatch('load_masters'),
        this.$store.dispatch('load_objects'),
        this.$store.dispatch('load_dealers')
      ])
      this.loading = false
    }
  },
  async mounted(){
    await this.load_gsa_data()
  },
  components:{
    Loader
  }
}
</script>